import { endpoints, REQUEST_METHODS } from '../constants';
import { apiSlice } from '../store';

export const authService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    authenticate: builder.mutation({
      query: (values) => ({
        url: endpoints.accounts.login,
        method: REQUEST_METHODS.POST,
        body: values
      })
    }),
    logout: builder.mutation({
      query: () => ({
        url: endpoints.accounts.logout,
        method: REQUEST_METHODS.POST
      })
    }),
    getProfile: builder.query({
      query: (staffId) => ({
        url: `${endpoints.accounts.profile}?staffId=${staffId}`,
        method: REQUEST_METHODS.GET
      })
    })
  })
});

export const {
  useAuthenticateMutation,
  useLogoutMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery
} = authService;
